var _defs, _ellipse, _g, _text, _g2, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNexusArenaWordmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 980,
    height: 320,
    viewBox: "0 0 980 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img",
    "aria-label": "NEXUS ARENA",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "nexusGold",
    x1: 126,
    y1: 80,
    x2: 854,
    y2: 270,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9e7a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#9b6c29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#fff6d8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b98637"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7ddb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "nexusSteel",
    x1: 170,
    y1: 118,
    x2: 810,
    y2: 318,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f8fafc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#cbd5e1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#ffffff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#94a3b8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "coreGlow",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(490 206) rotate(90) scale(168 430)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2563eb",
    stopOpacity: 0.65
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#7c3aed",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f172a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "softBlueGlow",
    x: 0,
    y: 0,
    width: 980,
    height: 390,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "blur",
    type: "matrix",
    values: "0 0 0 0 0.11 0 0 0 0 0.47 0 0 0 0 1 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "SourceGraphic",
    mode: "screen"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "titleShadow",
    x: 70,
    y: 60,
    width: 840,
    height: 250,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 14,
    stdDeviation: 18,
    floodColor: "#020617",
    floodOpacity: 0.88
  }), /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 0,
    stdDeviation: 9,
    floodColor: "#38bdf8",
    floodOpacity: 0.22
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 490,
    cy: 206,
    rx: 430,
    ry: 168,
    fill: "url(#coreGlow)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.72,
    filter: "url(#softBlueGlow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M174 246H366L408 206H572L614 246H806",
    stroke: "#2dd4ff",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212 270H390L430 236H550L590 270H768",
    stroke: "#7c3aed",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 236,
    r: 8,
    stroke: "#f8d477",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 490,
    cy: 236,
    r: 18,
    stroke: "#2563eb",
    strokeOpacity: 0.55,
    strokeWidth: 1
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 82,
    textAnchor: "middle",
    fill: "#f8d477",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: 12
  }, "\n    WEB3 COLLECTIBLE CARD GAME\n  ")), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#titleShadow)"
  }, /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 196,
    textAnchor: "middle",
    fill: "url(#nexusSteel)",
    stroke: "#111827",
    strokeWidth: 3,
    paintOrder: "stroke fill",
    fontFamily: "Inter, Roboto, Arial Black, sans-serif",
    fontSize: 92,
    fontWeight: 950,
    letterSpacing: 10
  }, "\n      NEXUS\n    "), /*#__PURE__*/React.createElement("text", {
    x: 490,
    y: 252,
    textAnchor: "middle",
    fill: "url(#nexusGold)",
    stroke: "#0f172a",
    strokeWidth: 2,
    paintOrder: "stroke fill",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontSize: 38,
    fontWeight: 900,
    letterSpacing: 20
  }, "\n      ARENA\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282 282H698",
    stroke: "url(#nexusGold)",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M316 302H664",
    stroke: "#38bdf8",
    strokeOpacity: 0.38,
    strokeWidth: 1,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexusArenaWordmark);
export default __webpack_public_path__ + "static/media/nexus-arena-wordmark.b3474f88ece71b0df1540cd660a77d7f.svg";
export { ForwardRef as ReactComponent };